var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3337 6.4818V6.66667V7.49967V16.6667V17.5H17.5003H2.50033H1.66699V16.6667V7.5V6.66667V3.33301C1.66699 2.87277 2.04009 2.49967 2.50033 2.49967H5.00033V0.833008H6.66699V2.49967H13.145C13.0507 2.81662 13 3.15239 13 3.5C13 3.72785 13.0218 3.95062 13.0634 4.16634H6.66699V4.99967H5.00033V4.16634H3.33366V6.66634H15.0067C15.4596 6.88033 15.9658 7 16.5 7C17.1723 7 17.8004 6.81042 18.3337 6.4818ZM13.3333 4.99265V4.99967H13.3367C13.3355 4.99733 13.3344 4.99499 13.3333 4.99265ZM3.33366 8.33333V15.8333H16.667V8.33333H3.33366Z",
    fill: "#8C8A94"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3337,
    cy: 3.61035,
    r: 2,
    fill: "#0BABFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarUpdate);
export default __webpack_public_path__ + "static/media/calendarUpdate.11f74b83634b7b7bf1a55216d6a7b1e9.svg";
export { ForwardRef as ReactComponent };